import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { IconButton } from "@mui/material";
import {
  GridRowId,
  gridDetailPanelExpandedRowIdsSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-premium";

/**
 * The detail-panel chevron.
 *
 * `GRID_DETAIL_PANEL_TOGGLE_COL_DEF`'s default cell draws nothing through the shared
 * DataGrid wrapper, so the toggle is driven off `apiRef` here instead — the same thing
 * the other detail-panel grids in this app do, for the same reason.
 */
export function InboundExpandCell({ id }: { id: GridRowId }) {
  const apiRef = useGridApiContext();
  const expanded = useGridSelector(apiRef, gridDetailPanelExpandedRowIdsSelector);
  const isExpanded = expanded.has(id);
  return (
    <IconButton
      size="small"
      aria-label={isExpanded ? "Hide email details" : "Show email details"}
      onClick={(e) => {
        e.stopPropagation();
        apiRef.current.toggleDetailPanel(id);
      }}
    >
      {isExpanded ? (
        <KeyboardArrowDown fontSize="small" />
      ) : (
        <KeyboardArrowRight fontSize="small" />
      )}
    </IconButton>
  );
}
